import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { BsCheck, BsEye, BsPencilSquare, BsTrash, BsX } from 'react-icons/bs';

interface Item {
    id: number;
    category: string;
    title: string;
    author: string;
    status: string;
    // Add more properties as per your item structure
}

interface currentApprovalsTableProps {
    items: Item[];
    onView: (id: number) => void;
    onApprove: (id: number) => void;
    onDecline: (id: number) => void;
}

export default function CurrentApprovalsTable({ items, onView, onApprove, onDecline  }: currentApprovalsTableProps) {

    const [approvalPage, setApprovalPage] = useState(1);
    const approvalPerPage = 5;

    const indexOfLastApproval = approvalPage * approvalPerPage;
    const indexOfFirstApproval = indexOfLastApproval - approvalPerPage;
    const pendingItems = items.filter(item => item.status === 'Pending');
    const currentApprovals = pendingItems.slice(indexOfFirstApproval, indexOfLastApproval);
    const totalPages = Math.ceil(pendingItems.length / approvalPerPage); 


    const nextApprovalPage = () => {
        if (approvalPage < totalPages) {
            setApprovalPage(approvalPage + 1);
        }
    };

    const prevApprovalPage = () => {
        if (approvalPage > 1) {
            setApprovalPage(approvalPage - 1);
        }
    };

    const [author, setAuthor] = useState<string | null>(null);
    const [role, setRole] = useState<string | null>(null);

    useEffect(() => {
        const storedAuthor = localStorage.getItem('author');
        const storedRole = localStorage.getItem('role');
        setAuthor(storedAuthor);
        setRole(storedRole);
    }, []);

    return (
        <>
            {(role === 'IT' || role === 'Magazine') && (
                <div className="container mt-5">
                    <h3 className='mb-1 font-semibold'>For Approval</h3>
                    <Table hover>
                        <thead className="bg-gray-400">
                            <tr>
                                <th>Category</th>
                                <th>Title</th>
                                <th>Author</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentApprovals.map(item => (
                                item.status === 'Pending' && (
                                    <tr key={item.id}>
                                        <td>{item.category}</td>
                                        <td>{item.title}</td>
                                        <td>{item.author}</td>
                                        <td>{item.status}</td>
                                        <td>
                                            <button onClick={() => onView(item.id)} className='bg-red-600 rounded-sm text-white text-xl' data-tooltip-id='preview'><BsEye /></button>
                                            <span> </span>
                                            <button onClick={() => onApprove(item.id)} className='bg-green-600 rounded-sm text-white text-xl' data-tooltip-id='Approved'><BsCheck /></button>
                                            <span> </span>
                                            <button onClick={() => onDecline(item.id)} className='bg-gray-600 rounded-sm text-white text-xl' data-tooltip-id='Declined'><BsX /></button>
                                        </td>
                                    </tr>
                                )
                            ))}
                        </tbody>
                    </Table>
                    <div className="flex justify-center items-center mt-4 space-x-4">
                    <button
                    onClick={prevApprovalPage}
                    className="px-4 py-2 rounded disabled:opacity-50 text-white bg-gray-500"
                    disabled={approvalPage === 1}
                >
                    Previous
                </button>
                <button
                    onClick={nextApprovalPage}
                    className="px-4 py-2 rounded disabled:opacity-50 bg-red-500"
                    disabled={approvalPage === Math.ceil(items.length / approvalPerPage)}
                >
                    Next
                </button>
                    </div>
                </div>
            )}
        </>
    )
}